import { IeltsInCentreNavigation, persistReducer } from '@britishcouncil/common-store';

const navigationStorageKey = 'NAVIGATION';

export const navigationReducer = persistReducer(IeltsInCentreNavigation.reducer, {
  key: navigationStorageKey,
  storage: localStorage,
  whitelist: ['activeOrganisation', 'activeCountry', 'activeCentre', 'activeLocation'],
});
